module.exports = __webpack_public_path__ + "img/15fb6aa.jpg";